import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ resourceType, namespace }) =>
    present(
      repository
        .getResourceGroups(resourceType, namespace)
        .then((groups) => ({ resourceType, namespace, groups }))
        .catch(() => Promise.reject({ resourceType, namespace })),
    );
}

export type { Interactor };

export { createInteractor };
